export default {
  path: "/apply",
  name: "apply",
  component: () => import("@/views/Apply.vue"),
  children: [
    {
      path: "/apply/holiday",
      name: "holiday",
      component: () => import("@/components/apply/ehr/holiday.vue"),
      meta: {
        title: "休假申请"
      }
    }
  ]
};
